import cn from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import ErrorBox from './ErrorBox';
import * as style from './Page.module.css';
import PageHeading from './PageHeading';
import SpinnerContainer from './SpinnerContainer';

export interface Props {
    title?: string;
    subTitle?: ReactNode;
    backUrl?: string;
    isSpinning?: boolean;
    error?: any;
    className?: string;
    whiteBackground?: boolean;
}

export default function Page({
    title,
    subTitle,
    backUrl,
    isSpinning = false,
    error,
    className,
    children,
    whiteBackground,
}: PropsWithChildren<Props>) {
    return (
        <div
            className={cn('section__inner-container', className, {
                [style.whiteBackground]: whiteBackground,
            })}
        >
            {(title || backUrl) && <PageHeading heading={title} subHeading={subTitle} backHref={backUrl} />}
            <SpinnerContainer isSpinning={isSpinning} className="full-page-spinner">
                <ErrorBox errors={error} />
                {children}
            </SpinnerContainer>
        </div>
    );
}
